module.exports = __webpack_public_path__ + "static/img/detail-meetingD.501a7ce6.png";